/**
 * Current product look (CGM orange) as the default skin.
 * Light and dark values match the hardcoded colors that existed before theming.
 */
const defaultSkin = {
  id: 'default',
  label: 'Classic',
  light: {
    primary: '#F89400',
    primaryHover: '#e88600',
    primaryActive: '#e08500',
    primaryContrast: '#ffffff',
    accent: '#ff9800',

    chromeBg: '#F89400',
    chromeFg: '#ffffff',
    chromeTabInactive: '#c97200',
    chromeTabInactiveHover: '#d98800',
    chromeSurface: '#f5a855',

    bgDefault: '#f5f5f5',
    bgPaper: '#ffffff',
    bgElevated: '#ffffff',
    bgSubtle: '#fafafa',
    bgDialogActions: '#f0f0f0',
    bgField: '#ffffff',
    textPrimary: 'rgba(0, 0, 0, 0.87)',
    textSecondary: 'rgba(0, 0, 0, 0.6)',
    textDisabled: 'rgba(0, 0, 0, 0.38)',
    divider: '#e0e0e0',
    border: '#e0e0e0',

    error: '#e3000f',
    errorContrast: '#ffffff',
    warning: '#fbba00',
    success: '#94c11c',
    info: '#0064a6',
    danger: '#D62E33',

    statusNew: '#0074bc',
    statusNewFg: '#ffffff',
    statusStarted: '#d4e6a4',
    statusStartedFg: '#94c11c',
    statusAwaiting: '#fbba00',
    statusAwaitingFg: '#ffffff',
    statusApproved: '#94c11c',
    statusApprovedFg: '#ffffff',
    statusProvisionally: '#7e57c2',
    statusProvisionallyFg: '#ffffff',
    statusRejected: '#D32F2F',
    statusRejectedFg: '#ffffff',
    statusCorrection: '#FFF8E1',
    statusCorrectionFg: '#F9A825',
    statusCorrectionBorder: '#FFF59D',

    emergencyNormal: '#2e7d32',
    emergencyNormalBg: 'rgba(46, 125, 50, 0.12)',
    emergencyUrgent: '#ed6c02',
    emergencyUrgentBg: 'rgba(237, 108, 2, 0.15)',
    emergencyEmergency: '#d32f2f',
    emergencyEmergencyBg: 'rgba(211, 47, 47, 0.12)',
    insurance: '#1565c0',
    insuranceBg: 'rgba(21, 101, 192, 0.12)',

    calDuty: '#1976d2',
    calOncall: '#f57c00',
    calVacation: '#388e3c',
    calAbsence: '#d32f2f',
    calTraining: '#7b1fa2',
    calBlocked: '#424242',
    calMaintenance: '#00796b',

    chart1: '#F89400',
    chart2: '#FF6F3C',
    chart3: '#9ecb45',
    chart4: '#FFB347',
    chart5: '#C86400',
    chart6: '#3c8de3',
    chart7: '#FFCF73',
    chart8: '#aa69b7',
    chart9: '#E8D3B0',
    chart10: '#A7C6ED',

    rulerDark: '#FFCA82',
    rulerLight: '#FFEBCF',
    rulerBg: 'transparent',
    marginColor: '#FFE0B5',
    marginBg: 'rgba(255, 202, 130, 0.1)',
    marginBorder: '#FF9F1C',

    chatGroup: '#9C27B0',
    chatMale: '#2196F3',
    chatFemale: '#E91E63',
    chatGroupHover: '#7B1FA2',
    chatMaleHover: '#1976D2',
    chatFemaleHover: '#C2185B',

    dbFieldBg: '#FDE7C7',
    scrollbarThumb: '#F89400',
    datagridBg: '#ffffff',
    datagridHeader: '#ffffff',

    demo1: '#d32f2f',
    demo2: '#7b1fa2',
    demo3: '#512da8',
    demo4: '#1976d2',
    demo5: '#0288d1',
    demo6: '#00796b',
    demo7: '#f57c00',
    demo8: '#616161',
  },
  dark: {
    primary: '#F89400',
    primaryHover: '#e88600',
    primaryActive: '#e08500',
    primaryContrast: '#ffffff',
    accent: '#ff9800',

    chromeBg: '#F89400',
    chromeFg: '#ffffff',
    chromeTabInactive: '#c26e00',
    chromeTabInactiveHover: '#d48000',
    chromeSurface: '#f5a855',

    bgDefault: '#212121',
    bgPaper: '#424242',
    bgElevated: '#2a2a2a',
    bgSubtle: '#1e1e1e',
    bgDialogActions: '#333333',
    bgField: '#424242',
    textPrimary: '#ffffff',
    textSecondary: '#bbbbbb',
    textDisabled: 'rgba(255, 255, 255, 0.38)',
    divider: '#424242',
    border: '#424242',

    error: '#e3000f',
    errorContrast: '#ffffff',
    warning: '#fbba00',
    success: '#94c11c',
    info: '#0064a6',
    danger: '#D62E33',

    statusNew: '#0074bc',
    statusNewFg: '#ffffff',
    statusStarted: '#d4e6a4',
    statusStartedFg: '#94c11c',
    statusAwaiting: '#fbba00',
    statusAwaitingFg: '#ffffff',
    statusApproved: '#94c11c',
    statusApprovedFg: '#ffffff',
    statusProvisionally: '#33691E',
    statusProvisionallyFg: '#DCEDC8',
    statusRejected: '#B71C1C',
    statusRejectedFg: '#FFCDD2',
    statusCorrection: '#FF8F00',
    statusCorrectionFg: '#FFF59D',
    statusCorrectionBorder: '#FFF59D',

    emergencyNormal: '#2e7d32',
    emergencyNormalBg: 'rgba(46, 125, 50, 0.12)',
    emergencyUrgent: '#ed6c02',
    emergencyUrgentBg: 'rgba(237, 108, 2, 0.15)',
    emergencyEmergency: '#d32f2f',
    emergencyEmergencyBg: 'rgba(211, 47, 47, 0.12)',
    insurance: '#1565c0',
    insuranceBg: 'rgba(21, 101, 192, 0.12)',

    calDuty: '#1976d2',
    calOncall: '#f57c00',
    calVacation: '#388e3c',
    calAbsence: '#d32f2f',
    calTraining: '#7b1fa2',
    calBlocked: '#424242',
    calMaintenance: '#00796b',

    chart1: '#F89400',
    chart2: '#FF6F3C',
    chart3: '#9ecb45',
    chart4: '#FFB347',
    chart5: '#C86400',
    chart6: '#3c8de3',
    chart7: '#FFCF73',
    chart8: '#aa69b7',
    chart9: '#E8D3B0',
    chart10: '#A7C6ED',

    rulerDark: '#FFCA82',
    rulerLight: '#FFEBCF',
    rulerBg: 'transparent',
    marginColor: '#FFE0B5',
    marginBg: 'rgba(255, 202, 130, 0.1)',
    marginBorder: '#FF9F1C',

    chatGroup: '#9C27B0',
    chatMale: '#2196F3',
    chatFemale: '#E91E63',
    chatGroupHover: '#7B1FA2',
    chatMaleHover: '#1976D2',
    chatFemaleHover: '#C2185B',

    dbFieldBg: '#867a69',
    scrollbarThumb: '#F89400',
    datagridBg: '#1e1e1e',
    datagridHeader: '#2a2a2a',

    demo1: '#d32f2f',
    demo2: '#7b1fa2',
    demo3: '#512da8',
    demo4: '#1976d2',
    demo5: '#0288d1',
    demo6: '#00796b',
    demo7: '#f57c00',
    demo8: '#616161',
  },
};

export default defaultSkin;
